import React from "react";
import PropTypes from "prop-types";
import { getDate } from "common/utils/dateUtil";
import styles from "./styles.module.scss";

const SubscriptionStartDate = ({ startDate }) => {
    return (
        <div className={ styles.startDate }>
            <span className={ styles.label }>Start Date: </span>
            <span className={ styles.text }>{ getDate(startDate) }</span>
        </div>
    );
};

SubscriptionStartDate.propTypes = {
    startDate: PropTypes.string.isRequired
};

export default SubscriptionStartDate;
